module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_styled_02-dec5258a196b7b2f41d1b42df40a9c97.png";